export class HomeMessages {
  public content = 'home.content';
  public createSign = 'home.create_sign';
  public eventThread = 'home.event_thread';
  public news = 'home.news';
  public verifySign = 'home.verify_sign';
  public access = 'home.access';
  public welcome = 'home.welcome';

  constructor() {
  }
}
